import { BadgeBox, Pill } from './styled';
export function Badge(props) {
    const { children, value, appearance = 'primary', dot = false, size = 'medium' } = props;
    return (<BadgeBox>
      {children}
      <Pill $adjustPosition={Boolean(children)} $appearance={appearance} $dot={dot} $size={size}>
        {value}
      </Pill>
    </BadgeBox>);
}
